/** GenWeb brand palette — shared by theme and standalone surfaces (e.g. login). */
export const BRAND_COLORS = {
    red: '#E2001A',
    redDark: '#a00505',
    black: '#1a1a1a',
    white: '#ffffff',
    gray: '#7d7a7e',
    grayLight: '#f5f5f5',
};
